import axios from 'axios'

export const FrontEndICodeMapService = {
  // get details based on icodes
  fetchIcodeDetailsList (icode) {
    return axios.get(`/public/api/v1/icodesearch?icode=${icode}`)
  }
}
